import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

// Services
import { getTranslateByKey } from "@/main/services/utils";

// Types
import { IGridList } from "../integrationRegisterScreen";

// Components
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";

// Components/Styles Local

import * as S from "./styles";

interface IIntegrationRegisterGrid {
	gridData: IGridList[];
	buttonDelete: (guid: string) => void;
	buttonEdit: (guid: string) => void;
}
function IntegrationRegisterGrid({ gridData, buttonDelete, buttonEdit }: IIntegrationRegisterGrid) {
	if (gridData.length === 0) return null;

	const rowHeaders = [
		getTranslateByKey("information.ipStart"),
		getTranslateByKey("information.ipEnd"),
		getTranslateByKey("information.actions"),
	];
	return (
		<BoxGrid rowHeaders={rowHeaders} maxHeight="375px" style={{ marginTop: "-1rem" }}>
			{gridData.map((item) => (
				<KOGTableRow key={item.guidList} id={`id-orderReport-tableRow-result-${item.guidList}`}>
					<S.TableCellGrid>
						<S.TableGrid>{item.ipAddressStart}</S.TableGrid>
					</S.TableCellGrid>
					<S.TableCellGrid>
						<S.TableGrid>{item.ipAddressEnd}</S.TableGrid>
					</S.TableCellGrid>
					<S.TableCellGridAction>
						<S.ButtonEditIcon
							aria-label={getTranslateByKey("information.edit")}
							onClick={() => buttonEdit(item.guidList)}
						>
							<EditIcon />
						</S.ButtonEditIcon>
						<S.ButtonCloseIcon
							aria-label={getTranslateByKey("information.deleted")}
							onClick={() => buttonDelete(item.guidList)}
						>
							<CloseIcon />
						</S.ButtonCloseIcon>
					</S.TableCellGridAction>
				</KOGTableRow>
			))}
		</BoxGrid>
	);
}

export default IntegrationRegisterGrid;
